import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, Inject, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { GlobalComponent } from "src/app/global/global.component";
import { CaregiverInfoLst, ClientAuthBO, ClientBO, ClientReturnBO, ContactInfoLst, disablePortalBO, EditDetailsClient, EmergencyContactInfoLst, GetUserBo, OfficeCaseManagerInfoLst, onBoardingListBO, ResponsibleInfoLst, SendToPortalBO, EmployerEmployeeRelationshipTaxPercentBO, GetListBO, GetListBase, WhereCondition, functionpermission } from "../client-parent.model";
import { IMyInputFieldChanged, IMyDateModel, IMyDpOptions } from "mydatepicker";
import { GeneralService } from "src/app/service/general.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DataStateChangeEventArgs, GridComponent, FilterSettingsModel } from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { DateService } from 'src/app/date.service';
import { ToastrService } from "ngx-toastr";
import { CommonHttpService } from "src/app/common.service";
import { BudgetImportBO } from "../../budgetplan-form/budgetplan-form.model";
import { ConfigurationService } from "src/app/configuration.service";
import { ClientEmployeeContactBO } from "../../client-employee-contact/client-employee-contact.model";
import { ClientEmployeeRelationshipBO } from "../../client-employee-relationship/client-employee-relationship.modal";
import { ClientHttpService } from "../client-parent.service";
import { clienttserivce } from "../clienttservice";
import { clienttserivcetax } from "../clientttaxservice";
import { purchaseBo } from "../../purchase-request/purchase-request.model";
import { ClientEmployeeDynamicFormBO } from "../../client-employee-dynamicform/client-employee-dynamicform.model";
import { promise } from "protractor";
import { resolve } from "path";
import { rejects } from "assert";

@Component({
  selector: "app-client-create-edit",
  templateUrl: "./client-create-edit.component.html",
  styleUrls: ["./client-create-edit.component.scss"],
})

export class ClientCreateEditComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridcarecoordinator') public gridcarecoordinator: GridComponent;
  @ViewChild('gridcasemanager') public caseenablegridcasemanager: GridComponent;
  @Input() DataFromList: EditDetailsClient = new EditDetailsClient();
  @Output() EventToEdit = new EventEmitter<EditDetailsClient>();
  RelationshipId: string | null;
  RelationForm: FormGroup;
  relationtaxform: FormGroup;
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public formatOptions: object
  arraycol: any = [];
  initialPage: any;
  filterOptions: FilterSettingsModel;
  RelationTaxPercentGridBO: GetListBO = new GetListBO();
  stateList: any = [];
  ///General tab////
  savedList: ClientBO;
  ClientErrList: string[] = [];
  ActiveTab = "nav-general";
  previousTab: string = "";
  contactvaluechange
  today = new Date();
  isSaveorUpdateClientBoolean: boolean = false;
  isEinList: any = [];
  disableEin: boolean = false;
  clientphone1Err: boolean = false;
  clientphone2Err: boolean = false;
  billto: boolean = false;
  userList: GetUserBo[] = [];
  PriorityStatus: any;
  clientemployeenamedropdown: any;
  relationdropdown: any;
  relationtaxdropdown: any;
  selectedLanguages: any = [];
  TypeofWaiver: any;
  saveClientInProgress: boolean = false;
  email_formvalidator: FormGroup;
  isViewUpdate: boolean = false;
  isAuthView: boolean = false;
  isNotes: boolean = false;
  statusList: any = [];
  locationList: any = [];
  genderList: any = [];
  isEditDisable: boolean;
  isShowFields: boolean;
  clientEvv: boolean = false;
  isRelationcontact: boolean = false;
  isEnabledcontact: boolean = false;
  isRelationShip: boolean = false;
  isEnabledRelationship: boolean = false;
  isEnabledNotes: boolean = false;
  isRelationShipTaxPercent = false;
  employeremployeerelationshipTaxPercentBO: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
  ClientEmployeeContact: ClientEmployeeContactBO = new ClientEmployeeContactBO();
  ClientAuthList: ClientAuthBO = new ClientAuthBO();
  ClientEmployeeRelationship: ClientEmployeeRelationshipBO = new ClientEmployeeRelationshipBO();
  isFieldEnabled: boolean;
  changevalue: boolean = false;
  pcaType: any = [];
  ShowAssessmentRate: string;
  AssessmentRating: any;
  purchaseEmitBo = new purchaseBo()
  getLocationList: any = [];
  supervisiondate: any;
  clientcasemanagerandContactDetail: any;
  ClientList: any = new ClientBO();
  Responsibleinfo: ResponsibleInfoLst = new ResponsibleInfoLst();
  Caregiversdetailsinfo: CaregiverInfoLst = new CaregiverInfoLst();
  EmergencyContactinfo: EmergencyContactInfoLst = new EmergencyContactInfoLst();
  OfficeCaseManagerinfo: OfficeCaseManagerInfoLst =
    new OfficeCaseManagerInfoLst();
  ///conatct tab///
  contactinfo: ContactInfoLst = new ContactInfoLst();
  contactfilter: any = "contacts";
  ContactInfoType: string = "edit";
  casetype: string = "";
  ContactInfoForm: FormGroup;
  ClientContactData: ContactInfoLst[] = [];
  ContactTypeList: any;
  ContactsType:boolean;
  conatactRelList: [{ Key: string, Value: string }];
  phoneCarrierList: [{ Key: string, Value: string }];
  LanguageList: [{ Key: string, Value: string }];
  ContactRelationshipList: [{ Key: string, Value: string }];
  relationenable: boolean = false;
  enablerelation: boolean = false;
  //contact tab casemanager//
  public datacase: Observable<DataStateChangeEventArgs>;
  deletecaseId: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  caseenable: boolean = false;
  //contact tab carecoodinator//
  deletecareId: string;
  careenable: boolean = false;
  caretype: string = "";
  isEditBoolean: boolean = false;
  public datacare: Observable<DataStateChangeEventArgs>;
  public data: Observable<DataStateChangeEventArgs>;
  ClientDataForm: FormGroup;
  PayerList: any = [];
  isClientDocument: boolean;
  AddressGoogleMap: boolean = false;
 CFSSAgencyList:any=[]
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
  fp: functionpermission = new functionpermission();
SupporPlanerList:any=[]
  constructor( private cdr: ChangeDetectorRef,public datepipe: DatePipe, public dateservice: DateService,
     public configurationservice: ConfigurationService, public http: HttpClient,
      private commonhttp: CommonHttpService, public ClientService: ClientHttpService, @Inject(clienttserivcetax) public clienttserivcetax: clienttserivcetax, public toasterService: ToastrService, public global: GlobalComponent, private general: GeneralService, private formBuilder: FormBuilder, fb: FormBuilder) {

    this.data = clienttserivcetax
    this.global.checkforlogout();

    // ...................ClientDataForm..........................................
    this.ClientDataForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
   //   dateofBirth: new FormControl('', [Validators.required]),
      genderLid: new FormControl('', [Validators.required]),
      statusLid: new FormControl('', [Validators.required]),
      locationId: new FormControl('', [Validators.required]),
      middleName: new FormControl(''),
      ClientPhone1: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      ClientPhone2: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      ClientEmail: new FormControl('', [Validators.email, Validators.required]),
      
      // username: new FormControl(""),

    });
    this.email_formvalidator = this.formBuilder.group({
      Email: ['', [Validators.email, Validators.required]],
    });

    //////////////////// RelationshipTax form ///////////////////////////////////////////
    this.relationtaxform = fb.group({
      employerEmployeeRelationshipId: [' '],
      employerEmployeeRelationshipTaxId: [''],
      percent: [''],
      effectiveDate: [''],




    })

  }
 

  ngOnInit(): void {
    
    this.global.clientId = this.DataFromList.clientId;
    this.getTabActiveData(this.ActiveTab);
    this.getLocationDropDown();
    this.getStatus();
    this.getPCATYPE();
    this.getPhoneCarrierStatus()
    this.getAssessmentRating();
    this.getContactRelationStatus()
    this.getTypeofWaiver();
    this.getPriorityStatus();
    this.getYesOrNoList();
    this.getGender();
    this.getRelationStatus();
    this.getStatesField();
    this.getLiveWithStatus();
    this.getrelationtaxpercentDataList();
    this.checkValidationforClient();
    this.getLanguage();
    this.GetLanguageList()
    this.getPaySourceDropDown();
    this.getCFSSagencyDropDown();
    this.getSupportPlannerDropDown();
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };

    //////////////// Set ClientId for Contact & Relation & Budget /////////////////////
    this.ClientEmployeeContact.ContactType = 'Client';
    this.ClientEmployeeContact.Id = this.DataFromList.clientId;
    this.ClientEmployeeRelationship.RelationshipType = 'Client';
    this.ClientEmployeeRelationship.Id = this.DataFromList.clientId;
    this.ClientAuthList.Id = this.DataFromList.clientId;
    this.ClientEmployeeDynamicForm.Dynamictype = "Client";
    this.ClientList.cFSSAgencyId=this.DataFromList.clientData.cfssAgencyId;
    this.ClientList.cyma_suta_rate=this.DataFromList.clientData.cyma_suta_rate;
    this.ClientList.isMAEligible=this.DataFromList.clientData.isMAEligible;
    if (this.global.clientId != "00000000-0000-0000-0000-000000000000") {
    this.ClientEmployeeDynamicForm.Id = this.global.clientId; 
      
      this.isEditDisable = true;
      this.isFieldEnabled = true;
      this.email_formvalidator.controls['Email'].disable();
      this.getValidateTaxErrorMessages(this.global.clientId,'editclient')     
    }
    else {
      this.isFieldEnabled = true;
    }

  }

 


  /////////////////////// validation for client /////////////////////////

  checkValidationforClient() {
    if (this.ClientList.id == "00000000-0000-0000-0000-000000000000") {
      this.ClientDataForm.enable();
      this.global.viewTabs = false;
    }
    else {
      this.isEditBoolean = true;
      this.global.viewTabs = true;
      this.ClientDataForm.disable();
    }
  }



  ////////////////////////// DATE FORMATCHANGE ////////////////////////
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.employeremployeerelationshipTaxPercentBO.effectiveDate = element;
        }
      }
      if (name == 'effectiveEndDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.employeremployeerelationshipTaxPercentBO.effectiveEndDate = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.employeremployeerelationshipTaxPercentBO.effectiveDate = element;
        }
      }
      // if (name == 'effectiveEndDate') {
      //   let val = this.dateservice.Datechange(event);
      //   if (val != undefined) {
      //     let element = this.dateservice.Datechange(event);
      //     this.employeremployeerelationshipTaxPercentBO.effectiveEndDate = element;
      //   }
      // }
    }
  }


  //======================================================== EDIT CLIENT=============================================//

  EditClientDetails() {
    this.isViewUpdate = true; //......... boolean for Updateclient.......//
    this.isFieldEnabled = false; //....... boolean for Field disable ..........//
    this.isEditBoolean = false; //......... boolean for Editclient......//
    this.global.viewTabs = false; //....... boolean for AllTabs ..........//
    this.ClientDataForm.enable();
  }

  //===========================================================Save And Update client===============================//
 
  async SaveorUpdateClient(ClientList,popval) {
    this.isSaveorUpdateClientBoolean=true;
    if(this.disableEin && (this.ClientList.isEin == "" || this.ClientList.isEin == null || this.ClientList.isEin == undefined)) {
      this.toasterService.error("Please enter EIN value");
      this.isSaveorUpdateClientBoolean=false;
      return
    } 
    console.log(popval,this.ClientList.id,"popval","ClientList")
    if(popval=='yes')
        document.getElementById("closewarningTaxPercentModal").click()

    if(this.ClientList.id != "00000000-0000-0000-0000-000000000000" && popval == 'no' ) {
     await this.getValidateTaxErrorMessages(this.ClientList.id,'updateclient');
     console.log("after set",this.taxErr_msg);
     if(this.taxErr_msg != '')
        return
    }
    let Clientsave = JSON.parse(JSON.stringify(ClientList));
    Clientsave.phone1 = Clientsave?.phone1 != null && Clientsave?.phone1 != undefined ? this.general.reconverPhoneGoogleLib(Clientsave?.phone1) :null;
    Clientsave.phone2 = Clientsave?.phone2 != null && Clientsave?.phone2 != undefined ? this.general.reconverPhoneGoogleLib(Clientsave?.phone2) :null;

    Clientsave.dOB = (this.ClientList.dOB != null && this.ClientList.dOB != undefined && this.ClientList.dOB != '' && this.ClientList.dOB != null) ? this.global.getDateTimeString(this.ClientList.dOB) : null;
    Clientsave.weight = (Clientsave.weight != null && Clientsave.weight != undefined && Clientsave.weight != '') ? parseInt(Clientsave.weight) : null;
    this.ClientService.saveClientData(Clientsave).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateClientBoolean=false;
      if (this.ClientList.id == "00000000-0000-0000-0000-000000000000") {
        this.toasterService.success('Client saved SuccessFully');
        this.isEditBoolean = true;
        this.ClientDataForm.disable();
        this.email_formvalidator.disable();
        this.global.viewTabs = true;
      }
      else {
        this.isFieldEnabled = false;
        this.toasterService.success('Client updated SuccessFully');
      }
      

      this.ClientList.id = data;
      this.ClientEmployeeContact.Id = data;
      this.ClientEmployeeRelationship.Id = data;
      this.ClientAuthList.Id = data;
      this.global.clientId = data;
     
    },
      (err: any) => {
        this.isSaveorUpdateClientBoolean=false;
        this.toasterService.error(err, "Error");
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);
      }

    )
  }
taxErr_msg:any;
validationType:string='updateclient';
 getValidateTaxErrorMessages(clientId: string,validationWay) {
  return new Promise((resolve,reject)=>{
    let myParams = new URLSearchParams();
  myParams.append("clientId", clientId);
 
      this.ClientService.getValidateTaxPercentmessages(myParams)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe({
      next: (data: string) => {
        this.isSaveorUpdateClientBoolean = false;
        console.log(data, 'response-----'); 
        resolve(data)
        this.taxErr_msg=data;        
       if (data) {
          this.validationType=validationWay                 
          document.getElementById("closewarningTaxPercentModal").click()
        } 
          //this.toasterService.error(data);
       
      },
      error: (err: HttpErrorResponse) => {
        this.isSaveorUpdateClientBoolean = false;
        console.log(err, "err-----");
        reject(err);
        this.toasterService.error(err.error);
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);
      }
    });
  })
  

  
}
  /////////////////// BACK CLIENTLIST/////////////
  BackToClientList() {
    this.global.viewTabs = false;
    this.back();
  }

  back() {
    this.DataFromList.isEdit = false;
    this.DataFromList.isView = true;
    this.EventToEdit.emit(this.DataFromList);
  }


  ////////////////////////// Client Medical Record ////////////////////

  Responsiblepartydetails(data: ResponsibleInfoLst) {
    this.Responsibleinfo = JSON.parse(JSON.stringify(data));
  }
  EmergencyContactdetails(data: EmergencyContactInfoLst) {
    this.EmergencyContactinfo = JSON.parse(JSON.stringify(data));
  }
  Caregiversdetails(data: CaregiverInfoLst) {
    this.Caregiversdetailsinfo = JSON.parse(JSON.stringify(data));
  }
  OfficeCaseManagerdetails(data: OfficeCaseManagerInfoLst) {
    this.OfficeCaseManagerinfo = JSON.parse(JSON.stringify(data));
  }
  BudgetImportData: BudgetImportBO = new BudgetImportBO();
  clientrelation: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();

  ClientEmployeeDynamicForm: ClientEmployeeDynamicFormBO =
  new ClientEmployeeDynamicFormBO();
  isdynamicFormcontact:boolean=false;
  ////////////////////Client TAB CHANGE////////////////////////

  getTabActiveData(Tabtocall) {
    this.ActiveTab = Tabtocall;
    if (Tabtocall != "nav-notes") {
      this.isEnabledNotes= false;
      this.isNotes= false;

    }
    if (Tabtocall == "nav-notes") {
      this.isNotes = true;
      
    }
    if(Tabtocall == "nav-DocumentClient-tab"){
      this.isClientDocument = true;
    }


    if (Tabtocall == "nav-general") {
      this.isFieldEnabled = false;
     }

    if (Tabtocall == "nav-contacts") 
    {
      this.isRelationcontact = true;
      this.ClientEmployeeContact.Relationtype="Contacts";

    }
    if (Tabtocall != "nav-contacts") 
    {
      this.isEnabledcontact = false;
      this.isRelationcontact = false;
      this.ClientEmployeeContact.Relationtype=null
    }

    if (Tabtocall != "nav-relationship")
     {
      this.isEnabledRelationship = false;
      this.isRelationShip = false;
    }
    if (Tabtocall == "nav-relationship") {
      this.isRelationShip = true;
    }
    if(Tabtocall == 'nav-DynamicClientForm') {
      this.isdynamicFormcontact = true;

    }
    if (Tabtocall != "nav-DynamicClientForm") {
      this.parentToOnboard.docToOnboarding = false
      this.isdynamicFormcontact = false
    }
    
    if (Tabtocall == "nav-relationshiptaxpercent") {
      this.isRelationShipTaxPercent = true;
      this.getrelationtaxpercentDataList();
      this.GetClientEmployeeRelationshipdropdown();
    }

    if (Tabtocall != "nav-authorization") {

      this.isAuthView = false;
    }
    if (Tabtocall == "nav-authorization") {
      this.isAuthView = true;
    }

    if (Tabtocall != "nav-documents") {
      this.parentToOnboard.docToOnboarding = false
    }
    if (Tabtocall == "nav-documents") {
      this.parentToOnboard.docToOnboarding = true;
      this.parentToOnboard.clientid = this.ClientList.id;
    }

    if (Tabtocall == "nav-budget") {
      this.BudgetImportData.clientId = this.global.clientId;

    }

    if (Tabtocall == "nav-purchase") {
      this.purchaseemit = true
      this.emitToPurchase();
    }
    if (Tabtocall != "nav-purchase") {
      this.purchaseemit = false

    }

    if (Tabtocall == "nav-certification") {
    }
    if (Tabtocall == "nav-carecoordinators") {
    }
    if (Tabtocall == "nav-casemanagers") {
    }
    if (Tabtocall == "nav-evaluation") {
    }
    if (Tabtocall == "nav-notes") {
    }
    
    
  }

  /////////////////// EMIT FOR PURCHASE ///////////////////
  purchaseemit = false
  emitToPurchase() {
    this.purchaseEmitBo.clientToPurchase = true;
    this.purchaseEmitBo.clientid = this.ClientList.id
    this.purchaseEmitBo.clientName = this.ClientList.name

  }

  /////////////////// EMIT FOR PURCHASE ///////////////////
  dataEmitFromCDCSPlan(event) {
    this.BudgetImportData.edit = false;
  }
  dataemitBudgetimport(event) {
    this.BudgetImportData.edit = false;
    this.BudgetImportData.clientId = null;
  }


  /////////////////// EMIT FOR DOCUMENT ///////////////////
  parentToOnboard: onBoardingListBO = new onBoardingListBO();
  reDirect() {
    this.parentToOnboard.docToOnboarding = true;

  }


  dataEmitFromOnboard(value) {
    this.parentToOnboard.docToOnboarding = false;
  }


  ////////////////////// CLIENT EIN changefunction ////////////////
  EinChangesFun(val) {

    var name = this.isEinList.filter((f) => f.id == val)[0]?.lovCode;
    if (name == "YES") {
      this.disableEin = true;


    } else {
      this.disableEin = false;
      this.ClientList.isEin = null;
    }
  }


  /////////////////////////// CLIENT SSN ///////////////////////////////////
  closeSsnValidation() {
    document.getElementById("closeClientssnModal").click();
  }

  ssnerr = false
  ClientChangeSSN() {
    if (this.ClientList.ssn != null && this.ClientList.ssn != undefined && this.ClientList.ssn != '') {

      if (this.ClientList.ssn.length != 0 && this.ClientList.ssn.length != 9) {
        this.ssnerr = true
      }
      else {
        this.ssnerr = false
      }
    }
    else {
      this.ssnerr = false
    }
  }

  //.............................................numbersOnly.......................................
  numbersOnly(event) {
    if (!this.global.isdigit(event.key)) {
      event.preventDefault();
    }
  }

  //.............................................keyPress.......................................
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  //.............................................. DOBdatechange..............................................
  DOBdatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length >=7  && value.substring(2, 3) != '/') {
      this.ClientList.dOB = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4);
    }
  }

  //............................................. CLIENT DOB CHNAGE............................................ 
  onDateChanged(event: IMyDateModel) {    
    this.ClientList.dOB = event.formatted;
    var bdate = new Date(event.formatted);
    var today = new Date();
    var bdate = new Date(event.formatted);
    var age = 0;
    if (bdate.getFullYear() >= today.getFullYear()) {
      age = 0
    }
    else {
      var age = today.getFullYear() - bdate.getFullYear();
      var m = today.getMonth() - bdate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < bdate.getDate())) {
        age--;
      }
    }
    this.ClientList.age = age;
    if (this.ClientList.dOB == null || this.ClientList.dOB == undefined || this.ClientList.dOB == '') {
      this.ClientList.age = null;
    }
  }

  //......................................DemographicPhoneFormat....................................
  DemographicPhoneFormat() {
    this.ClientList.phone1 = this.general.converPhoneGoogleLib(this.ClientList.phone1);
    this.ClientList.phone2 = this.general.converPhoneGoogleLib(this.ClientList.phone2);
    this.ClientList.billto_Phone = this.general.converPhoneGoogleLib(this.ClientList.billto_Phone)
  }

//................................................LOV DROPDOWN .............................................//

  //................................................getGender.................................................
  getGender() {
    let params = new URLSearchParams();
    params.append("listCode", "GENDER");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.genderList = data;

    })
  }
  //.............................................getRelationStatus..........................................................
  getRelationStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "RELATIONSHIP");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.forEach(element => {
        element.id = element.id.toString();
      });
      this.conatactRelList = data;

    })
  }
  //.............................................getLiveWithStatus..........................................................
  getLiveWithStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "LIVEWITH");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.forEach(element => {
        element.id = element.id.toString();
      });
      // this.conatactLiveWithList = data;
    })
  }
  //.............................................getPhoneCarrierStatus..........................................................
  getPhoneCarrierStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "PHONECARRIER");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.phoneCarrierList = data;
    })
  }

   //.............................................getLanguage..........................................................
   getLanguage() {
    let params = new URLSearchParams();
    params.append("listCode", "Language");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.LanguageList = data;
    })
  }
  //.............................................getStatus..........................................................
  getStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusList = data;
      if (this.global.clientId == '00000000-0000-0000-0000-000000000000') {
        this.ClientList.statusLid = this.statusList.filter(s => s.lovName == "Active")[0].id;
      }
    })
  }

  //............................................getLocationDropDown.............................................
  getLocationDropDown() {
    this.ClientService.GetLocationDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.getLocationList = data;
      if (this.getLocationList.length > 0) {
        this.ClientList.locationId =( this.ClientList.locationId!=null &&  this.ClientList.locationId!=undefined)?this.ClientList.locationId  : this.getLocationList[0]?.Key;
      }
    },
      err => {
      })
  }
  //......................................getPCATYPE..............................................
  getPCATYPE() {
    let params = new URLSearchParams();
    params.append("listCode", "PCATYPE");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.pcaType = data;
      this.pcaType.forEach(element => {
        element.id = element.id;
      });
    })
  }
  //......................................getAssessmentRating..............................................
  getAssessmentRating() {
    let params = new URLSearchParams();
    params.append("listCode", "ASSESSMENTRATING");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.AssessmentRating = data;
      this.AssessmentRating.forEach(element => {
        element.id = element.id
      });
    })
  }
  //..............................................getTypeofWaiver.................................................
  getTypeofWaiver() {
    let params = new URLSearchParams();
    params.append("listCode", "TYPEOFWAIVER");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.TypeofWaiver = data;
      this.TypeofWaiver.forEach(element => {
        element.id = element.id;
      });
    })

  }
  //.............................................getContactRelationStatus..............................................
  getContactRelationStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "RELATIONSHIP");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.ContactRelationshipList = data;
    })

  }

  //............................................... GetState ......................................//
  getStatesField() {
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;

    });
  }

  //.............................................getPriorityStatus..............................................
  getPriorityStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "PRIORITYSTATUS");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.PriorityStatus = data;

    });

  }

  //.............................................getYesOrNoList..............................................
  getYesOrNoList() {
    let params = new URLSearchParams();
    params.append("listCode", "YESORNO");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isEinList = data;
      this.EinChangesFun(this.ClientList.isEinLid);

    })
  }
  //.............................................getPayerSourceDropDown.......................................

  getPaySourceDropDown(){
    this.ClientService.getPayerSourceDropdown().pipe(takeUntil(this.onDestroy$)).subscribe(data =>{
      this.PayerList = data
    });
  }
 
  getCFSSagencyDropDown(){
    this.ClientService.getCFSSAgencyDropdown().pipe(takeUntil(this.onDestroy$)).subscribe(data =>{
      this.CFSSAgencyList = data
    });
  }
  getSupportPlannerDropDown(){
  

     let params = new URLSearchParams();
    params.append("clientId", this.ClientList.id);
    let url = "api/SupportPlanner/GetCientSupportDropdown?"

    this.commonhttp.GetFunctionwithResponseTypeText(
      params, url
    ).subscribe(
      (res) => {
        //window.open(res);
        this.SupporPlanerList=JSON.parse(res);
        console.log(this.SupporPlanerList,"SupporPlanerList");
      },
      (err: any) => {
        this.toasterService.error(err, "Error"), 8000;
      }
    );
  }
  //.............................................ngOnChanges..............................................
  ngOnChanges(changes: SimpleChanges) {
    this.ClientList = this.DataFromList.clientData;
    this.GetLanguageList();
    if(this.ClientList.userName != null && this.ClientList.userName != undefined && this.ClientList.userName != ""){
      this.ClientList.requiredEVV = true;
    }
    else{
      this.ClientList.requiredEVV = false;
    }
    setTimeout(() => {
      this.ClientList.dOB =(this.DataFromList.clientData.dOB != null && this.DataFromList.clientData.dOB != '' && this.DataFromList.clientData.dOB != undefined) ?this.datepipe.transform(this.DataFromList.clientData.dOB, "MM/dd/yyyy"):null;
      // this.ClientDataForm.controls['dateofBirth'].setValue(this.ClientList.dOB)

    }, 300);
    this.ClientList.assessmentRatingLid = (this.ClientList.assessmentRatingLid != null && this.ClientList.assessmentRatingLid != '' &&
      this.ClientList.assessmentRatingLid != undefined) ? this.ClientList.assessmentRatingLid.toString() : null;
    this.ClientList.typeofWaiverLid = (this.ClientList.typeofWaiverLid != null && this.ClientList.typeofWaiverLid != '' &&
      this.ClientList.typeofWaiverLid != undefined) ? this.ClientList.typeofWaiverLid.toString() : null;
  }


   //////////////////////////////// CREATE CLIENT PORTAL ///////////////////////////////////////////
  sendToPortalBO: SendToPortalBO = new SendToPortalBO();
  ClearingNotes() {
    this.sendToPortalBO.agencyNote = ''
  }

  CreatePoratl() {
    this.sendToPortalBO.clientId = this.ClientList.id;
    this.sendToPortalBO.agencyNote = this.sendToPortalBO.agencyNote;
    this.sendToPortalBO.username = this.sendToPortalBO.username;
    this.sendToPortalBO.statusLid = this.ClientList.statusLid;
    this.sendToPortalBO.portalLink = this.configurationservice.environment.onboardingUrl + '#/onboarding/client/'
    this.ClientService.SentToClient(this.sendToPortalBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('PORTALMODAL').click();
      this.toasterService.success("Portal Created Successfully");
      this.ClientList.loginUserId = data.loginUserId;
      this.ClientList.userName = data.userName;
      this.ClientList.userName != null && this.ClientList.userName != undefined && this.ClientList.userName != "" ? this.ClientList.requiredEVV = true : this.ClientList.requiredEVV = false;
    },
      (err: any) => {
        this.toasterService.error(
          err,
          "Error",
        );
        setTimeout(() => {
          this.toasterService.clear()
        }, 8000);
      }
    )
  }





  // ..............................................RELATION TAX PERCENT......................................................//

  GetClientEmployeeRelationshipdropdown() {
    let params = new URLSearchParams();
    params.append("ClientId", this.ClientList.id);
    this.ClientService.ClientEmployeRelationShipDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.clientemployeenamedropdown = data;

  

    })
  }

  ModelType: string;
  Createupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.employeremployeerelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
      this.relationtaxform.reset();
      this.RelationshipId = null
    }
    else {
      this.ModelType = 'edit';
    }

  }

  GetRelationshipdropdown(cliempid) {
    let params = new URLSearchParams();
    params.append("ClientId", cliempid);
    this.ClientService.ClientRelationShipDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.relationdropdown = data;
      this.relationdropdown.forEach(s => {
        this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId = s.Key


      })
      this.GetRelationshipTaxdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);

    })
  }

  GetRelationshipTaxdropdown(relationshipIp) {
    let params = new URLSearchParams();
    params.append("EmployerEmployeeRelationshipId", relationshipIp);
    this.ClientService.ClientRelationShipTaxDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.relationtaxdropdown = data;

    })
  }
  
  edit(data) {
    this.employeremployeerelationshipTaxPercentBO = JSON.parse(JSON.stringify(data));
    this.employeremployeerelationshipTaxPercentBO.effectiveDate = this.datepipe.transform
      (this.employeremployeerelationshipTaxPercentBO.effectiveDate, "MM/dd/yyyy");
      this.employeremployeerelationshipTaxPercentBO.effectiveEndDate 
      =  this.employeremployeerelationshipTaxPercentBO.effectiveEndDate  != null &&  this.employeremployeerelationshipTaxPercentBO.effectiveEndDate != undefined &&
      this.employeremployeerelationshipTaxPercentBO.effectiveEndDate  != ''?      
      this.datepipe.transform
      (this.employeremployeerelationshipTaxPercentBO.effectiveEndDate, "MM/dd/yyyy")  :null
    this.GetRelationshipdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);
    this.RelationshipId=this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId;
    //this.GetRelationshipTaxdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);
  }

  // ................................................................................................................................
  
  SaveList: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
  isSaveorUpdateBoolean:boolean=false;
  SaveOrUpdateActivity(type: string) {
    this.isSaveorUpdateBoolean=true;
    var saveList: EmployerEmployeeRelationshipTaxPercentBO = JSON.parse(JSON.stringify(this.employeremployeerelationshipTaxPercentBO));
    saveList.id = this.employeremployeerelationshipTaxPercentBO.id;
    saveList.effectiveDate = this.global.getDateTimeString(this.employeremployeerelationshipTaxPercentBO.effectiveDate)
    saveList.effectiveEndDate =this.employeremployeerelationshipTaxPercentBO.effectiveEndDate != null && 
    this.employeremployeerelationshipTaxPercentBO.effectiveEndDate != undefined &&
    this.employeremployeerelationshipTaxPercentBO.effectiveEndDate != ''     
    ?
     this.global.getDateTimeString(this.employeremployeerelationshipTaxPercentBO.effectiveEndDate):null
     this.ClientService.saveupdaterelationtaxpercent(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {

        this.SaveList.id = data;
        if (this.ModelType == 'new') {

          this.toasterService.success('Relationshiptaxpercent  saved successfully!');

          document.getElementById('opentaxpercentModal').click();
          this.getrelationtaxpercentDataList();
        }
        else {
          this.toasterService.success('Relationshiptaxpercent updated successfully!');

          document.getElementById('opentaxpercentModal').click();
          this.getrelationtaxpercentDataList();

        }

      }
    }, (err: any) => {
      
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }

  public ContactId: string;
  setDeleteId(value) {
    this.ContactId = value;
  }
  DeleteTaxPercent() {

    let param = new URLSearchParams()
    param.append("employerEmpRelTaxPercentId", this.ContactId)
    this.ClientService.deleterelationtaxpercent(param).subscribe((_data: any) => {
      this.toasterService.success("RelationShip Tax-percent deleted successfully!");
      document.getElementById("closeTaxPercentModal").click();
      this.getrelationtaxpercentDataList();

    },
      err => {
        this.toasterService.error(err.error);
      })

  }
  getrelationtaxpercentDataList() {
    this.RelationTaxPercentGridBO.clientId = this.global.clientId;
    this.clienttserivcetax.executetax(this.RelationTaxPercentGridBO);
    let count = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;

    })
  }


  ///////////////////////////////// FILTER FUNCTION ////////////////////////////
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.RelationTaxPercentGridBO.orderColumn = state.sorted[0].name;
        this.RelationTaxPercentGridBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.RelationTaxPercentGridBO.field = state.action.currentFilterObject.field;
      this.RelationTaxPercentGridBO.matchCase = state.action.currentFilterObject.matchCase;
      this.RelationTaxPercentGridBO.operator = state.action.currentFilterObject.operator;
      this.RelationTaxPercentGridBO.value = state.action.currentFilterObject.value;
      if(this.RelationTaxPercentGridBO.type != "string" && this.RelationTaxPercentGridBO.value == null || this.RelationTaxPercentGridBO.value == undefined || this.RelationTaxPercentGridBO.value == ''){
        this.RelationTaxPercentGridBO.field = "employerEmployeeRelationshipName";
        this.RelationTaxPercentGridBO.matchCase = false;
        this.RelationTaxPercentGridBO.operator = "startswith";
        this.RelationTaxPercentGridBO.type = "string";
        this.RelationTaxPercentGridBO.value = "";
      }
      if(this.RelationTaxPercentGridBO.type == "number"){
        this.RelationTaxPercentGridBO.value = this.RelationTaxPercentGridBO.value?.toString();
        this.RelationTaxPercentGridBO.type = "decimal";
      }
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.RelationTaxPercentGridBO.field = "employerEmployeeRelationshipName";
        this.RelationTaxPercentGridBO.matchCase = false;
        this.RelationTaxPercentGridBO.operator = "startswith";
        this.RelationTaxPercentGridBO.type = "string";
        this.RelationTaxPercentGridBO.value = "";
      }
    }
    this.getrelationtaxpercentDataList();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Vendor.Pagesize != state.take) {
          this.arraycol[0].vendor.Pagesize = state.take


        }

      }
    }
  }
  public onActionComplete(args) {

    this.RelationTaxPercentGridBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.RelationTaxPercentGridBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }

  
  


  // disablePortalBtn = false
  // getPortalCheck() {

  //   if (this.ClientList.id != null && this.ClientList.id != undefined && this.ClientList.id != '00000000-0000-0000-0000-000000000000') {
  //     let params = new URLSearchParams();
  //     params.append("ClientId", this.ClientList.id);
  //     this.ClientService.getportalCreateCheck(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //       console.log(data);
  //       if (data) {
  //         console.log("if")
  //         this.disablePortalBtn = false
  //       } else {
  //         console.log("false")
  //         this.disablePortalBtn = true
  //       }
  //     })
  //   }

  // }

  ngAfterContentChecked() {
    this.ClientList.dOB =(this.DataFromList.clientData.dOB != null && this.DataFromList.clientData.dOB != '' && this.DataFromList.clientData.dOB != undefined) ?(this.DataFromList.clientData.dOB):null;
    // this.ClientDataForm.controls['dateofBirth'].setValue(this.ClientList.dOB);
    this.cdr.detectChanges();
  }




  GetLanguageList() {
    if(this.DataFromList.clientId!=null&&this.DataFromList.clientId!=undefined&&this.DataFromList.clientId!=''){
    let clientlanguagelist = [];

      let params = new URLSearchParams();
      params.append("ClientId", this.DataFromList.clientId);
      
      this.ClientService.ClientLanguageList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          
          clientlanguagelist?.push(element.languageLid)
        });
        this.ClientList.languageLid=clientlanguagelist
        
    })
   
  }
  }

  disablelogin: boolean = true;
   //......................................switchchange.....................................
   switchchange() {
    if (this.ClientList.requiredEVV) {
      document.getElementById('PORTALMODAL').click();
      // this.disablelogin = false;
    } else {
      document.getElementById('openEvvModal').click();
      // this.disablelogin = true;
    }
  }

    //......................................passwordResetFunction.....................................
    passwordResetFunction() {
        if (
          this.ClientList.loginUserId != null &&
          this.ClientList.loginUserId != undefined &&
          this.ClientList.loginUserId != ""
        ) {
          let params = new URLSearchParams();
          params.append("LoginUserId", this.ClientList.loginUserId);
          // params.append("userRole", "CLIENT");
          let url = "api/Client/removeEvvClientCredential?";
          this.ClientService.GetFunctionwithResponseTypeText(params, url)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data: any) => {
                document.getElementById("openEvvModal").click();
                this.toasterService.success("EVV Disabled Successfully");
                this.sessionLogout();
              },
              (err: any) => {
                this.toasterService.error("Kindly refresh the application!");
              }
            );
        }
      }

     //......................................sessionLogout.....................................
  sessionLogout() {
    let params = new URLSearchParams();
    params.append("RefreshTokenString", this.global.refreshTokenString);
    params.append("UserId", this.DataFromList.clientId.toString());
    params.append("userRole", "CLIENT");
    params.append("UserName", this.ClientList.userName);
    params.append("AgencyCode", this.global.agencyCode);
    let url = "api/Auth/sessionLogout?";
    this.ClientService
      .GetFunctionwithResponseTypeText(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ClientList.userName = null;
        },
        (err: any) => {
          this.toasterService.error(err, "error");
        }
      );
  }

  ngOnDestroy(){
    this.global.viewTabs=false
    this.global.clientId = this.global.globalclientdata = null;
  }

  EmitGoogleMapComponent(event) {
    this.ClientList.zipCode = "";
    this.ClientList.street = "";
    this.ClientList.city = "";
    this.ClientList.county = "";
    this.ClientList.state = "";
    this.ClientList.apt = "";
    let street="";
    if (
      event.address_components != null &&
      event.address_components != undefined
    ) {
      event.address_components.forEach((outerArray) => {
        outerArray?.types.forEach((innerArray) => {
          if (innerArray == "administrative_area_level_2") {
            this.ClientList.county = outerArray.long_name;
          }
          if (innerArray == "postal_code") {
            this.ClientList.zipCode = outerArray.long_name;
          }
          if (innerArray == "administrative_area_level_1") {
            if (outerArray.long_name != null) {
              let state = this.stateList?.filter(
                (a) => a.name == outerArray.long_name
              )[0];

              this.ClientList.state = state != null ? state.abbreviation : null;
            }
          }
          if (innerArray == "subpremise") {
            let apt = outerArray.long_name.split(" ")[1];
            this.ClientList.apt = (apt !=undefined && apt !=null && apt !='')? apt : outerArray.long_name;
          }
          if (innerArray == "street_number") {
            street = (outerArray.long_name !=undefined && outerArray.long_name !=null) ? outerArray.long_name +' ' :'';            
          }
          if (innerArray == "route") {
            this.ClientList.street = street + outerArray.short_name;
          }
        });
      });
    }
    if (event.formatted_address != null) {
      var addressFormat = event.formatted_address.split(",");
      // this.ClientList.street = addressFormat[0];
      this.ClientList.city = addressFormat[1];
    }
    this.ClientList.clientLocationLatitude = (event.clientLocationLatitude !=null && event.clientLocationLatitude !=undefined) ? event.clientLocationLatitude : null;
    this.ClientList.clientLocationLongitude = (event.clientLocationLongitude != null && event.clientLocationLongitude != undefined) ? event.clientLocationLongitude : null
    this.changevalue = event.isChanged;
  }
  ChangeContacType() {
    console.log(this.ClientEmployeeContact.Relationtype);
    
  }

}
